// extracted by mini-css-extract-plugin
export default {"error":"SimulationParametersError_error__1g0YG"};